import { AloDbBase, IAloDbBaseConstParam } from '@/models/alodb/AloDbBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'

export interface IAloDbUmbClasseConstParam extends IAloDbBaseConstParam {
    UMC_ID:number|null
    UMC_KEY:string|null
    UMC_LIBELLE:string|null
  }

export class AloDbUmbClasse extends AloDbBase {
        
    public UMC_ID:number|null
    public UMC_KEY:string|null  
    public UMC_LIBELLE:string|null
    
    constructor({UMC_ID,UMC_KEY,UMC_LIBELLE,...args }:IAloDbUmbClasseConstParam = {} as IAloDbUmbClasseConstParam) {
        super(args)
        this.UMC_ID = UMC_ID
        this.UMC_KEY = UMC_KEY
        this.UMC_LIBELLE = UMC_LIBELLE        
    }

    static createAloDbUmbClasseArray(datas:any) {
        return new AloBaseArray(AloDbUmbClasse,datas)
    }

    static createAloDbUmbClasseWithDetail(data:any) {
        return new AloDbUmbClasse({...data,detailLoaded:true})
    }
}
